import React from 'react'
import { withRouter } from 'react-router'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'

import StaffContainer from './StaffContainer'

class StaffShowPage extends React.Component {
    componentDidMount() {
        document.title = 'Staff | OSH CRM'
    }

    render () {
        const { id } = this.props.match.params

        return (
            <Layout>
                    <LayoutContentWrapper breadcrumbs={[
                        { path: '/staffs', name: 'Staffs' },
                        { path: `/staffs/${id}`, name: id }
                    ]}>
                        <ContentLayout>
                            <StaffContainer staffId={id} />
                        </ContentLayout>
                    </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default withRouter(StaffShowPage)
